import React from "react";

export default function SaleDaysLeft(props) {
  const { display_days_left, days_left } = props.details;
  const urgent = days_left < 2 ? "urgent" : "";

  if (display_days_left == "") {
    return null;
  } else {
    return (
      <div className={`sale-daysleft ${urgent}`}>
        <span className="glyphicon glyphicon-time"></span>
        {` ${display_days_left} `}
      </div>
    );
  }
}
